
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class InstamojoSettingsGrid extends Serenity.EntityGrid<InstamojoSettingsRow, any> {
        protected getColumnsKey() { return InstamojoSettingsColumns.columnsKey; }
        protected getDialogType() { return InstamojoSettingsDialog; }
        protected getIdProperty() { return InstamojoSettingsRow.idProperty; }
        protected getInsertPermission() { return InstamojoSettingsRow.insertPermission; }
        protected getLocalTextPrefix() { return InstamojoSettingsRow.localTextPrefix; }
        protected getService() { return InstamojoSettingsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}